export const isAscii = string => /^[\x00-\x7F]*$/.test(string) // eslint-disable-line no-control-regex

export const isUtf8 = string =>
  /^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ ;,.'"=@&+_’()!|–":/°\t\r\n-]*$/.test(
    string
  )
